import { useEffect, useState } from "react";

import { SaveButtonStatusType } from "types/apps-container";

import GoAiguaTextInput from "components/generic/goaiguatextinput";
import ModalContentLayout from "components/generic/modal-content-layout.component";

import { useTranslation } from "utils/hooks/use-translation.hook";
import { makeCreateAppsGroupsModalFunctions } from "utils/components/create-apps-groups-modal-functions";
import { useAppsContainerTabContext } from "storage/context/apps-container-tab-context";

type Props = {
    closeModalFn: () => void;
};

const CreateAppsGroupsModalContent = ({ closeModalFn }: Props) => {
    const [inputText, setInputText] = useState("");
    const [saveButtonStatus, setSaveButtonStatus] =
        useState<SaveButtonStatusType>("disabled");

    const translate = useTranslation();

    const {
        createMode,
        containers,
        createSubgroupTarget,
        setError,
        subscribeContent,
        unsubscribeContent,
        setContainers,
    } = useAppsContainerTabContext();

    const {
        defineCreateStrategy,
        defineTextBasedOnCreateMode,
        handleInputChange,
    } = makeCreateAppsGroupsModalFunctions({
        containers,
        createMode,
        createSubgroupTarget,
        inputText,
        closeModalFn,
        setContainers,
        setError,
        setInputText,
        setSaveButtonStatus,
        subscribeContent,
        translate,
        unsubscribeContent,
    });

    useEffect(() => {
        const defineSaveButtonStatus = () => {
            return inputText.length ? "enabled" : "disabled";
        };

        setSaveButtonStatus(defineSaveButtonStatus());
    }, [inputText]);

    return (
        <ModalContentLayout
            firstButtonStatus="enabled"
            secondButtonStatus={saveButtonStatus}
            firstButtonTitle={translate("app.gis.cancel")}
            secondButtonTitle={translate("app.users.save")}
            onFirstButtonClick={closeModalFn}
            onSecondButtonClick={defineCreateStrategy()}
        >
            <div className="c-creates-apps-groups-modal-content">
                <GoAiguaTextInput
                    id="group-name"
                    text={inputText}
                    className={"c-creates-apps-groups-modal-content__input"}
                    onChange={handleInputChange}
                    maxLength={48}
                    label={defineTextBasedOnCreateMode(
                        "app.welcome.page.edit.modal.input.label"
                    )}
                />
            </div>
        </ModalContentLayout>
    );
};

export default CreateAppsGroupsModalContent;
